import { Options } from '@/components/mi-dialog/MiDialog';
import DataTable, { TableOptions, TableVisibility, DatatableInterface } from '@/components/data-table/DataTable';
import { Component, Prop } from 'vue-property-decorator';
import AbstractDatatable from '@/components/CustomDatatable/AbstractDatatable';
import { GoodsIn, GoodsInTableHeader, GoodsInTypeEnum } from '@/models/GoodsIn';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<GoodsInDatatable>({})
export default class GoodsInDatatable extends AbstractDatatable implements DatatableInterface {

  // #region @Props

  @Prop({ default: '' })
  protected purchaseOrderNr!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected defaultPage = 1;

  protected selectedGoodsIn: null | GoodsIn = null;

  protected tableVisibility: TableVisibility = {
    checkboxes: false,
    search: false,
    title: false,
    limit: true,
    pagination: true,
  };

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get page() {
    const result = localStorage.getItem(`${this.$route.name}_page`);
    return result ? Number(result) : this.defaultPage;
  }

  protected set page(page: number) {
    localStorage.setItem(`${this.$route.name}_page`, page.toString());
    this.defaultPage = page;
  }

  protected get tableOptions(): TableOptions {
    return {
      model: new GoodsIn()
        .include(['media'])
        .filter({
          purchase_order_number: this.purchaseOrderNr,
        }),
      name: {
        singular: 'Goods in',
        plural: 'Goods in'
      },
      headers: [
        GoodsInTableHeader.media,
        GoodsInTableHeader.item_name,
        GoodsInTableHeader.delivery_date,
        GoodsInTableHeader.goods_in_reference_number,
        GoodsInTableHeader.quantity,
        GoodsInTableHeader.delivery_note_number,
      ],
      actions: [],
      filters: [],
    }
  }

  protected get deleteGoodsInDialogOptions(): Options {
    return {
      title: 'Delete attachment from purchase order',
      text: 'Are you sure you wish to delete this attachment from the purchase order?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedGoodsIn) {
              return;
            }

            this.selectedGoodsIn
              .delete()
              .then((response: any) => {
                if (response) {
                  this.refresh(true);
                  this.selectedGoodsIn = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedGoodsIn = null;
          },
        },
      },
    };
  }

  // #endregion

  // #endregion

  // #region @Watchers
  // #endregion
}
